import * as LedgerActions from './actions';

const initialState = {
  synced: false,
  changingMp: false,
  dealing: false,
  retrived: false,
  confirmedDeal: false
}

const ledgerReducer = (state = initialState, action) => {
  switch (action.type) {
    case LedgerActions.TX_SUCCESSFUL: {
      return {
        ...state,
        synced: true,
      }
    }
    case LedgerActions.ETH_REFRESHED: {
      return {
        ...state,
        synced: false,
      }
    }
    case LedgerActions.RETRIVED_GT: {
      return {
        ...state,
        retrived: action.retrived
      }
    }
    case LedgerActions.RETRIVED_WILLS: {
      return {
        ...state,
        retrivedW: action.retrivedW
      }
    }
    case LedgerActions.COMMITTING_CHANGING_MP: {
      return {
        ...state,
        changingMp: action.changingMp
      }
    }
    case LedgerActions.COMMITTING_DEAL: {
      return {
        ...state,
        dealing: action.dealing
      }
    }
    case LedgerActions.CONFIRMED_DEAL: {
      return {
        ...state,
        confirmedDeal: action.confirmedDeal
      }
    }
    case LedgerActions.COMMITTED_DEAL: {
      return {
        ...state,
        confirmedDeal: action.confirmedDeal
      }
    }
    default: {
      return state;
    }
  }
}

export default ledgerReducer;
